import { gql } from "@apollo/client";

const GET_ACTIVE_WHATSAPP_CALL = gql`
  query GetActiveWhatsAppCall($callId: String) {
    getActiveWhatsAppCall(callId: $callId) {
      id
      callId
      inboxId
      agentId
      from
      to
      phoneNumberId
      customerName
      status
      sdpOffer
      sdpAnswer
      direction
      startTime
      updatedAt
    }
  }
`;

export default GET_ACTIVE_WHATSAPP_CALL;
